import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { SnackbarProvider } from "notistack";
import {
  ApolloClient,
  ApolloProvider,
  HttpLink,
  InMemoryCache,
} from "@apollo/client";
import store, { persistor } from "./redux/store";
import {
  MetronicLayoutProvider,
  MetronicSplashScreenProvider,
  MetronicSubheaderProvider,
} from "./_metronic/layout";
import { MetronicI18nProvider } from "./_metronic/i18n";
import App from "./app/App";
import { createRoot } from 'react-dom/client';

import "./index.scss";
import "./_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
import "socicon/css/socicon.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";
import "react-datepicker/dist/react-datepicker.css";
 
 
const mapLink = new HttpLink({
  uri: "/proxy/map",
  headers: {
    user: "5f882f1e0411593ba0dad277",
  },
});
 
const client = new ApolloClient({
  link: mapLink,
  cache: new InMemoryCache(),
});


const domNode = document.getElementById('root');
const root = createRoot(domNode);

// root.render(
//   <MetronicI18nProvider>
//     <MetronicLayoutProvider>
//       <MetronicSubheaderProvider>
//         <MetronicSplashScreenProvider>
//           <SnackbarProvider maxSnack={3}>
//             <ApolloProvider client={client}>
//               <App store={store} persistor={persistor} />
//             </ApolloProvider>
//           </SnackbarProvider>
//         </MetronicSplashScreenProvider>
//       </MetronicSubheaderProvider>
//     </MetronicLayoutProvider>
//   </MetronicI18nProvider>
// );


ReactDOM.render(
  <MetronicI18nProvider>
    <MetronicLayoutProvider>
      <MetronicSubheaderProvider>
        <MetronicSplashScreenProvider>
          <SnackbarProvider maxSnack={3}>
            <ApolloProvider client={client}>
              <App store={store} persistor={persistor} />
            </ApolloProvider>
          </SnackbarProvider>
        </MetronicSplashScreenProvider>
      </MetronicSubheaderProvider>
    </MetronicLayoutProvider>
  </MetronicI18nProvider>,
  document.getElementById("root")
);

// const container = document.getElementById('root');
// const root = createRoot(container);
// root.render(<MetronicI18nProvider>
//   <MetronicLayoutProvider>
//     <MetronicSubheaderProvider>
//       <MetronicSplashScreenProvider>
//         <SnackbarProvider maxSnack={3}>
//           <ApolloProvider client={client}>
//             <App store={store} persistor={persistor} />
//           </ApolloProvider>
//         </SnackbarProvider>
//       </MetronicSplashScreenProvider>
//     </MetronicSubheaderProvider>
//   </MetronicLayoutProvider>
// </MetronicI18nProvider>
// );